<template>
  <el-dialog title="关联角色配置" :visible.sync="dialogVisible" width="520px">
    <el-checkbox :indeterminate="isIndeterminate" :value="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
    <div style="margin: 15px 0;" />
    <div style="max-height: 300px;overflow-y: auto;">
      <el-checkbox-group v-model="checkes" @change="handleCheckChange">
        <div v-for="item in roleList" :key="item.role_id" style="margin-bottom: 8px;">
          <el-checkbox v-model="item.role_id" :label="item.role_id">{{ item.role_name }}</el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveConfig">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { roleList } from '@/api/accountInfo'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, Number],
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      checkes: [],
      roleList: []
    }
  },
  computed: {
    // 当前所有公司id
    allIds() {
      return this.roleList.map(item => item.role_id)
    },
    checkAll() {
      const filterCheckList = this.checkes.filter(item => this.allIds.includes(item))
      const checkedCount = filterCheckList.length
      const childCount = this.allIds.length
      return checkedCount >= childCount
    },
    isIndeterminate() {
      const filterCheckList = this.checkes.filter(item => this.allIds.includes(item))
      const checkedCount = filterCheckList.length
      const childCount = this.allIds.length
      return checkedCount > 0 && checkedCount < childCount
    },
    doubleVar() {
      const { value, roleList } = this
      return { value, roleList }
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
      if (value) {
        // 显示弹框就去请求
        this.queryRoleList()
      }
    },
    dialogVisible(value) {
      !value && this.$emit('update:visible', false)
    },
    doubleVar({ value, roleList }) {
      if (roleList.length) {
        if (+value === -1) {
          this.checkes = [...roleList.map(d => d.role_id)]
        } else {
          this.checkes = [...value.map(d => Number(d))]
        }
      }
    }
  },
  methods: {
    async queryRoleList() {
      const res = await roleList({ page: 1, pageSize: 999999 })
      if (res.code === 200) {
        this.roleList = res.data.data
      }
    },
    handleCheckAllChange(val) {
      if (val) {
        // 全选
        this.checkes = [...new Set([...this.checkes, ...this.allIds])]
      } else {
        // 取消全选
        this.checkes = this.checkes.filter(item => !this.allIds.includes(item))
      }
      this.$emit('input', this.checkes)
    },
    handleCheckChange(val) {
      this.checkes = val
      this.$emit('input', this.checkes)
    },
    async saveConfig() {
      if (!this.checkes.length) {
        this.$message('请至少选择一个角色')
        return false
      }
      this.$emit('submitFn', this.checkAll ? -1 : this.checkes.join(','))
    }
  }
}
</script>

<style>

</style>
